export const LOSS_CATEGORIES = [
  "Price / budget", "Timing", "Competitor", "Scope / fit",
  "No decision / silent", "Authority / approval", "Not interested (no detail)", "Other",
];
